import type { FC } from 'react';
import { memo } from 'react';

import { parsePath, Target } from './helpers';
import { previewComponents, UnknownPreview } from './previewComponents';
import type { IProcessPreview } from './types';

export const ProcessPreview: FC<IProcessPreview> = memo((props) => {
  const { url, loading, Fallback, RenderComponent, type, ...rest } = props;

  const renderContent = () => {
    if (!url) return null;

    const fileType = type || parsePath(url, Target.Type);

    if (!fileType) {
      return <Fallback />;
    }

    if (RenderComponent) {
      return <RenderComponent url={url} Fallback={Fallback} {...rest} />;
    }

    const mime = previewComponents.find((c) => c.mimes.includes(fileType));

    const Component = mime || UnknownPreview;

    return <Component url={url} Fallback={Fallback} {...rest} />;
  };

  return renderContent();
});
